import { Coleccion, DataColeccionista } from '../../../../../models/coleccionitas.model';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import {MatStepperModule} from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject, map, Observable, of, startWith, switchMap, take } from 'rxjs';
import { InformaciónTecnicaComponent } from '../../detalle-bien-cultural/tabs/informacion-tecnica/informacion-tecnica.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistroBienCulturalService } from '../registro-bien-cultural.service';
import { Coleccionista } from 'app/models/coleccionitas.model';
import { environment as env } from 'environments/environments';
import { RegistroBienCulturalDTO } from 'app/models/registro-bien-cultural.model';
import { SeccionBienesCulturales } from 'app/models/datos-navegacion-solicitudes-gestiones';
import { UtilsService } from 'app/modules/utils-service';
import { RegistroBienCulturalResponse } from 'app/models/response-registro-bien-cultural.model';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural/detalle-bien-cultural.service';
import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { MatSelectModule } from '@angular/material/select';
import { RegistroBienInmueble } from 'app/models/registo-bien-inmueble.model';
import { ArrowBackComponent } from "../../../../GlobalComponents/arrow-back.component";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CONSTANTS } from 'app/core/constants';

@Component({
    selector: 'form-bien-cultural',
    templateUrl: 'form-bien-cultural.component.html',
    imports: [
    CommonModule,
    MatIconModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatTabsModule,
    MatSelectModule,
    ArrowBackComponent,
    MatCheckboxModule
],
})

export class FormBienCulturalComponent implements OnInit {
    formGroup:UntypedFormGroup;
    poseedorCtrl = new FormControl(); 
    departamentoCtrl = new FormControl();

    coleccionistas$: Observable<DataColeccionista[]>;
    filtroColeccionitas$: Observable<DataColeccionista[]>
    filter$ = new BehaviorSubject<string>('');

    filterDepartamento$ = new BehaviorSubject<string>('');
    allDepartamentos: Tipologia[] = [];
    departamentos$: Observable<Tipologia[]>;

    filterMunicipios$ = new BehaviorSubject<string>('');
    allMunicipios: Tipologia[] = [];
    municipios$: Observable<Tipologia[]>;

  
    descripcionColeccion: string = '';
    bienInmueble:boolean= false
    readonlyPropietario: boolean = false;
    esPropietario:boolean = false
   
    seccion:number
    titulo:string
    coleccionistaSeleccionado:DataColeccionista
    departamentos:Tipologia[]=[]
    municipios:Tipologia[]=[]
    titular:Tipologia[]=[]
    tipoPropiedad:Tipologia[]= []
    colecciones:Tipologia[]=[]
    codigoColeccionista:string
    
    tipologiaBienInmueble:number = env.TIPOLOGIA_ID_BIEN_INMUEBLE
    tipologiaBienMueble:number = env.TIPOLOGIA_ID_BIEN_MUEBLE
    tipology_departamentos:number= env.TIPOLOGIA_ID_DEPARTAMENTOS
    typology_id_bienes_inmuebles:number= env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES   

    TIPOLOGY_ID_TITULAR:number = CONSTANTS.TIPOLOGIA_ID_TITULAR
    ID_PROPIETARIO:number = CONSTANTS.TIPOLOGIA_ID_PROPIETARIO
    ID_POSEEDOR:number= CONSTANTS.TIPOLOGIA_ID_POSEEDOR
    SECCION_PREHISPANICA: number= CONSTANTS.TIPOLOGIA_ID_SECCION_PREHISPANICA

    tiposColeccion:number[]= [
      CONSTANTS.TIPOLOGIA_ID_COLECCION_PREHISPANICA, 
      CONSTANTS.TIPOLOGIA_ID_COLECCION_BIENES_INMUEBLES, 
      CONSTANTS.TIPOLOGIA_ID_COLECCION_HISPANICA_REPUBLICANA
    ]


    constructor(
        private _formBuilder: FormBuilder, 
        private route:Router,
        private registroBienService:RegistroBienCulturalService,
        private _utilsService: UtilsService,
        private activatedRoute: ActivatedRoute,
        private detalleBienesService:DetalleBienCulturalService
    ) {
        this.coleccionistas$= this.registroBienService.coleccionistas$ 
     }

    ngOnInit() {   

      this.getDepartamentos()
      
        const seccion = SeccionBienesCulturales.find(item => item.seccion === this.registroBienService.seccion_uuid_value);
        this.titulo = seccion?.titulo ?? '';
        this.seccion=this.registroBienService.seccion_uuid_value
        
        this.getTitular()
        this.getColecciones()
        this.getTipoPropiedad()

        this.formGroup = this._formBuilder.group({
            nombre: ['', Validators.required],
            tipoDeBien: ['', Validators.required],
            tipoPropiedad: [{ value: '', disabled: false }, Validators.required],
            propietarioId: [''],
            coleccion: [null],
            seccion:[this.seccion, Validators.required],
            departamento:[null],
            municipio:[null],
            titular:[''],
            finca:[''],
            folio:[''],
            libro:[''],
            propietarioNombre:[this.seccion === this.SECCION_PREHISPANICA? 'Estado de Guatemala': ''],
            nombrePoseedor:['']
        });

        this.formGroup.get('tipoDeBien')?.valueChanges.subscribe(tipo => {
          this.aplicarValidaciones(tipo);
        });

        // Si la sección es la del inmueble, marca el radio correspondiente
        if (this.seccion === this.typology_id_bienes_inmuebles) {
            this.bienInmueble= true
            this.formGroup.patchValue({
                  tipoDeBien: this.tipologiaBienInmueble
                
                });
        }           
          
        this.filtroColeccionitas$ = this.filter$.pipe(
            switchMap((query) => 
              this.coleccionistas$.pipe(
                map(coleccionistas =>
                  coleccionistas.filter(c =>
                    c.coleccionista.nombre.toLowerCase().includes(query.toLowerCase())
                  )
                )
              )
            )
          );

          this.poseedorCtrl.valueChanges.subscribe((coleccionista: DataColeccionista) => {
            if (coleccionista?.coleccionista.coleccionistaId && coleccionista?.coleccionista.coleccion?.tipologiaId) {
              this.formGroup.patchValue({
                propietarioId: coleccionista.coleccionista.coleccionistaId,
                coleccion: coleccionista.coleccionista.coleccion.tipologiaId,
              });
              if(this.esPropietario){
                  this.formGroup.patchValue({
                  propietarioNombre: coleccionista?.coleccionista.nombre,
                })
              }
          
              this.descripcionColeccion = coleccionista.coleccionista.coleccion.descripcion;
            } else {
              this.formGroup.patchValue({
                propietarioId: '',
                coleccion: '',
              });
              this.descripcionColeccion = '';
            }
          });


          //Auto-completar formulario si trae queryparams
          this.activatedRoute.queryParams.subscribe(params => {
            this.codigoColeccionista = params['coleccionista'];
            if (this.codigoColeccionista) {
              this.formGroup.patchValue({
                tipoDeBien: this.tipologiaBienMueble
              });
              this.coleccionistas$.pipe(take(1)).subscribe(coleccionistas => {
                const coleccionista = coleccionistas.find(c => c.coleccionista.codigoColeccionista === this.codigoColeccionista);
                if (coleccionista) {
                  this.poseedorCtrl.setValue(coleccionista);
                }
              });
            }
          }); 

          //si la seccion es prehispanica se el propietario es el estado
          if (this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
              this.readonlyPropietario = true;
              this.formGroup.patchValue({
                propietarioNombre: 'Estado de Guatemala',
              })
          }      
          
    }

    getDepartamentos() {
        this.detalleBienesService.getTipologias(this.tipology_departamentos).then((response: Tipologia[]) => {
            this.allDepartamentos = response;
    
              this.departamentos$ = this.filterDepartamento$.pipe(
              switchMap(query =>
                of(this.allDepartamentos).pipe(
                  map(departamentos =>
                    departamentos.filter(d =>
                      d.descripcion.toLowerCase().includes(query.toLowerCase())
                    )
                  )
                )
              )
            );
        });
    }
      
    getMunicipios1(event:TipologiasInterface){
        this.detalleBienesService.getTipologias(event.tipologiaId)
        .then((response: Tipologia[]) => {
            this.allMunicipios = response;

            this.municipios$ = this.filterMunicipios$.pipe(
              switchMap(query =>
                of(this.allMunicipios).pipe(
                  map(municipios =>
                    municipios.filter(d =>
                      d.descripcion.toLowerCase().includes(query.toLowerCase())
                    )
                  )
                )
              )
            );
        });
    }
      
    getColecciones(): void {
      let tipologiaIdColeccion: number = 0;

      if (this.seccion === env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES) {
        tipologiaIdColeccion = this.tiposColeccion[1];
      } else if (this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
        tipologiaIdColeccion = this.tiposColeccion[0];
      } else if (this.seccion === env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA) {
        tipologiaIdColeccion = this.tiposColeccion[2];
      }

      this.detalleBienesService.getTipologias(tipologiaIdColeccion)
        .then((response: Tipologia[]) => {
          this.colecciones = response;
        })
        .catch(error => {
          console.error('Error al obtener colecciones:', error);
        });
    }

    getTitular(){
        this.detalleBienesService.getTipologias(this.TIPOLOGY_ID_TITULAR)
        .then((response:Tipologia[])=>{
            this.titular= response
            this.formGroup.patchValue({
              titular: this.titular[0].tipologiaId,
            });
        }) 
    }

    getTipoPropiedad(){
      this.detalleBienesService.getTipologias(env.TIPOLOGIA_ID_TIPO_PROPIEDAD)
        .then((response:Tipologia[])=>{
            this.tipoPropiedad= response
            if(this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA){
              this.formGroup.patchValue({
                tipoPropiedad: this.tipoPropiedad.find(
                  tipo => tipo.tipologiaId === CONSTANTS.TIPOLOGIA_ID_PROPIEDAD_PUBLICA
                )?.tipologiaId // <- accedes solo al ID
              });


              this.formGroup.get('tipoPropiedad')?.disable();
            }
        })
    }

    onTipoDeBienChange(valor: any) {
      this.bienInmueble = valor === this.tipologiaBienInmueble;
    }

    aplicarValidaciones(tipo: number) {
      const controles = this.formGroup.controls;

      const camposInmueble = ['departamento', 'municipio', 'titular', 'finca', 'folio', 'libro', 'propietarioNombre'];
      const camposMueble = ['propietarioId', 'coleccion', 'propietarioNombre'];

      const aplicarA = (campos: string[], validadores: ValidatorFn[] = []) => {
        campos.forEach(campo => {
          if (controles[campo]) {
            controles[campo].setValidators(validadores);
            controles[campo].reset();
            controles[campo].updateValueAndValidity();
          }
        });
      };

      if (tipo === this.tipologiaBienInmueble) {
        aplicarA(camposMueble); // sin validadores = limpia y quita validaciones
        aplicarA(camposInmueble, [Validators.required]);
        
        this.poseedorCtrl.reset();
        this.descripcionColeccion = '';

        // establece propietario por defecto si es prehispánica
        if (this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
          this.readonlyPropietario = true;
          this.formGroup.patchValue({ propietarioNombre: 'Estado de Guatemala' });
        }

        // asigna titular por defecto
        this.formGroup.patchValue({
          titular: this.titular[0]?.tipologiaId,
        });

      } else {
        aplicarA(camposMueble, [Validators.required]);
        aplicarA(camposInmueble); // limpia y quita validaciones

        if (this.seccion === env.TIPOLOGIA_ID_SECCION_PREHISPANICA) {
          this.readonlyPropietario = true;
          this.formGroup.patchValue({ propietarioNombre: 'Estado de Guatemala' });
        }
      }
    }



    //SI EL COLECCIONISTA TAMBIEN ES PROPIETARIO ASIGNA EL NOMBRE DE COLECCIONISTA AL PROPIETARIO
    isOwner(isOwner: boolean) {
      const coleccionista = this.poseedorCtrl.value;
      if (isOwner) {
        this.esPropietario = true;
        this.formGroup.patchValue({
          propietarioNombre: coleccionista?.coleccionista.nombre 
        });
      }else{
         this.esPropietario = false;
        this.formGroup.patchValue({
          propietarioNombre: ''
        });
      }
    }

    onTitularChange(value: number): void {
        const nombrePoseedorControl = this.formGroup.get('nombrePoseedor');

        const esPoseedor = value === this.ID_POSEEDOR;
        this.esPropietario = !esPoseedor;

        if (esPoseedor) {
          nombrePoseedorControl?.setValidators([Validators.required]);
        } else {
          nombrePoseedorControl?.setValue('');
          nombrePoseedorControl?.clearValidators();
        }

        nombrePoseedorControl?.updateValueAndValidity();
    }

    guardarBienCultural() {
        let form:any
        this.bienInmueble
        ? form= new RegistroBienInmueble(this.formGroup.value)
        : form = new RegistroBienCulturalDTO(this.formGroup.value);
        this.registroBienService.registroBienCultural(form)
        .then((response:RegistroBienCulturalResponse)=>{
            this._utilsService.openSuccessSnakBar(`${form.nombre} se ha agregado correctamente.`)
            this.route.navigate([`bienes-culturales/detalle/${response.data.uuid}`]);
        })
    }

    displayFn(coleccionista: DataColeccionista): string { 
        this.coleccionistaSeleccionado= coleccionista   
        return coleccionista 
        ? `(${coleccionista?.coleccionista.codigoColeccionista}) - ${coleccionista?.coleccionista.nombre}`
        : '';
    }
  
    displayFnMunicipio(municipio: Tipologia): string {
      return municipio ? municipio.descripcion : '';
    }

    displayFnDepartamento(departamento: Tipologia): string {
      return departamento ? departamento.descripcion : '';
    }

    trackById(index: number, item: Coleccionista): any {
        return item.coleccionistaId;
    }


}